import type { RootState } from '@/store';

import type { ConversaFeedbackState } from '../types/negociacaoFeedbackTypes';
import { emptyConversaFeedback } from './slice';

const EMPTY_ENTRY: ConversaFeedbackState = emptyConversaFeedback();

export const selectFeedbackByConversa =
  (conversaId: string | null | undefined) =>
  (state: RootState): ConversaFeedbackState =>
    (conversaId ? state.negociacaoFeedback.byConversa[conversaId] : undefined) ?? EMPTY_ENTRY;
